import localeDataset from '@wix/locale-dataset-javascript';

// Formatting copied from
// https://github.com/wix-private/address-formatting-evaluator/blob/master/packages/address-formatting-evaluator/src/utils.ts

export const formatStreetNumber = (isStreetFormat, streetAddress) => {
  if (!isStreetFormat) {
    return '';
  }
  const number = (streetAddress == null ? void 0 : streetAddress.number) || '';
  const apt = streetAddress != null && streetAddress.apt ? `-${streetAddress.apt}` : '';
  return number ? `${number}${apt}` : '';
};
export const formatAddressLine = (isStreetFormat, streetAddress, addressLine) => {
  if (!isStreetFormat) {
    return addressLine;
  }
  const streetNumber = formatStreetNumber(isStreetFormat, streetAddress);
  return `${(streetAddress == null ? void 0 : streetAddress.name) || ''} ${streetNumber}`;
};
export function formatMultilineAddress(submission, t, language) {
  const country = localeDataset.getCountryByShortKey(submission.country);
  // Our proto is currently incorrectly defined, will fix types once backend changes proto
  const streetAddress = {
    name: submission.streetName,
    number: submission.streetNumber,
    apt: submission.apartment
  };
  const isStreetFormat = Object.values(streetAddress).some(Boolean);
  const formattedAddress = localeDataset.getFormattedAddress({
    country: country ? t(country.displayName, {
      lng: language
    }) : submission.country,
    subdivision: submission.subdivision,
    city: submission.city,
    zipCode: submission.postalCode,
    addressLine1: formatAddressLine(isStreetFormat, streetAddress, submission.addressLine),
    addressLine2: submission.addressLine2
  }, country == null ? void 0 : country.key);
  return formattedAddress.replace(/^[\s,]+|[\s,]+$/g, '');
}
//# sourceMappingURL=format-multiline-address.js.map